import React from 'react';

import SmartLink from '../../components/Library/SmartLink';
import Panel from '../../components/Panel';
import { useAccountContext } from '../../contexts/AccountContext';
import { getIcon } from '../../libs/libIcon';

const Links: React.FC = () => {
  const accountContext = useAccountContext();

  return <>
    <div className='px-4'>
      <div>
        <h3 className='text-2xl'>Links</h3>
      </div>
      <div className='flex flex-wrap w-full'>
        {accountContext.orgLinks.map((link) => (
          <div key={link.name} className='w-full md:w-1/5 m-2'>
              <SmartLink to={link.url} target={'_blank'} targetExternal={true}>
                <Panel innerClassName='p-4'>
                  <div className='w-full flex flex-col'>
                    <div className='p-1 mx-auto text-8xl'>
                      {getIcon(link.icon_url ?? undefined, 'text-[7rem]', 'h-28 w-28')}
                    </div>
                    <div className='pt-2 mx-auto'>
                      {link.name}
                    </div>
                  </div>
                </Panel>
              </SmartLink>
          </div>
        ))}
        {accountContext.orgLinks.length === 0 && <>
          <div className='pl-2 text-lg'>
            No Links Available
          </div>
        </>}
      </div>
    </div>

  </>;
};

export default Links;
